import { render, staticRenderFns } from "./LoginFormHeader.vue?vue&type=template&id=023c1514"
import script from "./LoginFormHeader.vue?vue&type=script&lang=js"
export * from "./LoginFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports